import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {FieldType, MemberAddeditComponent, MemberAddeditDialogModel} from '../member-addedit/member-addedit.component';
import {VendorGroupsProductsService} from '../../../services/vendor-groups-products/vendor-groups-products.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UiAlertService} from '../../../services/ui-alert/ui-alert.service';
import {VendorGroupsPlansService} from '../../../services/vendor-groups-plans/vendor-groups-plans.service';
import {UtilsService} from '../../../services/utils/utils.service';
import {MatSort} from '@angular/material/sort';
import {fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import _ from 'lodash';

@Component({
  selector: 'app-vendor-groups-plans',
  templateUrl: './vendor-groups-plans.component.html',
  styleUrls: ['./vendor-groups-plans.component.scss']
})
export class VendorGroupsPlansComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('search') search: ElementRef | undefined;

  protected allColumnNames = ['createdAt', 'vendorGroupProductId', 'metadata', 'actionmenu'];
  protected items = new MatTableDataSource<any>();
  protected groupProducts: any;

  private addEditFields = [
    {name: 'vendorGroupProductIds', label: 'Group Product', fieldType: FieldType.F_DROPDOWN, multiple: true, values: Array<any>(), required: true},
    {name: 'metadata', label: 'Configuration JSON', fieldType: FieldType.F_JSON, required: true},
  ];

  constructor(
      private vendorGroupsProductsService: VendorGroupsProductsService,
      private dialog: MatDialog,
      private snackBar: MatSnackBar,
      private uiAlertService: UiAlertService,
      private vendorGroupsPlansService: VendorGroupsPlansService,
      private utilsService: UtilsService,
      private activatedRoute: ActivatedRoute,
      private router: Router
  ) {

  }

  ngOnInit(): void {
    this.reloadItems();
  }

  ngAfterViewInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      // @ts-ignore
      this.search.nativeElement.value = params.get('search') || '';
      this.reloadItems();
    });
    fromEvent(this.search?.nativeElement, 'keyup').pipe(
        filter(Boolean),
        debounceTime(300),
        distinctUntilChanged(),
        tap((): void => {
          this.reloadItems();
          this.router.navigate([] , {
            relativeTo: this.activatedRoute,
            queryParams: {search: this.search?.nativeElement.value ?? ''},
            queryParamsHandling: 'merge'
          });
        })).subscribe();
  }

  private reloadItems(): void {
    this.vendorGroupsPlansService.getAllVendorGroupPlans(10000, 0, this.search?.nativeElement.value ?? '').then(plans => {
      this.items.data = plans;
      this.items.sort = this.sort;
    });
    this.vendorGroupsProductsService.getAllVendorGroupProducts().then(products => {
      this.groupProducts = products;
      this.addEditFields[0].values = _.sortBy(products.map((vendor: { metadata: any; vendorProductName: any; id: any; }) => `${vendor.vendorProductName} (${vendor.metadata.shortName} ${vendor.metadata.tag || ''}):${vendor.id}`));
    });
  }

  getGroupProduct(item: any): string {
    if (!item.vendorGroupProductIds || !Array.isArray(item.vendorGroupProductIds)) {
      return '';
    }

    const matches = this.groupProducts
        ?.filter((product: any) => item.vendorGroupProductIds.includes(product.id))
        .map((product: any) =>
            `${product.vendorProductName} (${product.metadata?.shortName || ''}${product.metadata?.tag ? ' ' + product.metadata.tag : ''})`
        );

    return matches && matches.length ? matches.join(', ') : '';
  }

  addItem(): void {
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(null, this.addEditFields, 'Group Plan')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.vendorGroupsPlansService.createVendorGroupPlan(dialogResult.vendorGroupProductIds, dialogResult.metadata).then(() => {
          this.reloadItems();
          this.snackBar.open('New group plan created');
        });
      }
    });
  }

  editItem(item: any): void {
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(item, this.addEditFields, 'Group Plan')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.vendorGroupsPlansService.modifyVendorGroupPlan(item.id, dialogResult).then(() => {
          this.reloadItems();
          this.snackBar.open('Group plan updated');
        });
      }
    });
  }

  duplicateItem(item: any): void {
    this.vendorGroupsPlansService.createVendorGroupPlan(item.vendorGroupProductIds, item.metadata).then(() => {
      this.reloadItems();
      this.snackBar.open('Duplicate group plan created');
    });
  }

  removeItem(item: any): void {
    this.uiAlertService.presentAlertConfirm('Do you really want to remove this group plan?').then(ok => {
      this.vendorGroupsPlansService.deleteVendorGroupPlan(item.id).then(() => {
        this.reloadItems();
        this.snackBar.open('Group plan removed');
      });
    });
  }

  truncateJSONString(str: string, maxLength: number): string {
    str = JSON.stringify(str);
    return str.length <= maxLength ? str : str.slice(0, maxLength - 3) + '...';
  }

}
